import { H2 } from 'foundations-components/transitional/components/H2';
import { H1 } from 'foundations-components/transitional/components/H1';
import styled from 'foundations-theming/utils';
import PublicPageBreadcrumbs from './PublicPageBreadcrumbs';
import I18n from 'I18n';
import EmbeddedSignup from '../../embeddedSignup/components/EmbeddedSignup';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { forwardRef } from 'react';
import { View } from 'foundations-components/components/View';
import { CardGrid } from 'foundations-components/transitional/components/CardGrid';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { Tag } from 'foundations-components/transitional/components/Tag';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Background = styled.div.withConfig({
  displayName: "PublicLandingPagePrimaryDetails__Background"
})(["position:absolute;z-index:-1;top:0;left:calc((100vw - 100%) / 2 * -1);height:100%;width:100vw;&::before{content:'';display:block;background:", ";width:100%;height:100%;}"], props => `${props.theme.color['fill-surface-recessed']}`);
const Description = styled.p.withConfig({
  displayName: "PublicLandingPagePrimaryDetails__Description"
})(["color:", ";a{text-decoration:underline;&:hover{color:", ";}}"], ({
  $use,
  theme
}) => $use === 'on-dark' ? theme.color['text-core-on-fill-default'] : theme.color['text-core-default'], ({
  $use,
  theme
}) => $use === 'on-dark' ? theme.color['text-interactive-on-fill-hover'] : theme.color['text-interactive-default-hover']);
const CONTENT_TYPE_MESSAGE = {
  CERTIFICATION: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academyPublic.contentLandingPage.primaryDetails.contentType.certification"
  }),
  TRACK: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academyPublic.contentLandingPage.primaryDetails.contentType.course"
  }),
  LESSON: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academyPublic.contentLandingPage.primaryDetails.contentType.lesson"
  })
};
const PublicLandingPagePrimaryDetails = /*#__PURE__*/forwardRef(({
  contentType,
  headline,
  name,
  description,
  parentName,
  parentPath,
  id,
  pagePath
}, ref) => {
  const {
    isMobile
  } = useMediaQuery();
  return /*#__PURE__*/_jsxs(View, {
    as: "section",
    "data-test-id": "public-landing-page-primary-details",
    marginBlockEnd: "800",
    minBlockSize: "450px",
    paddingBlockEnd: "800",
    paddingBlockStart: "800",
    position: "relative",
    children: [/*#__PURE__*/_jsx(Background, {}), /*#__PURE__*/_jsx(PublicPageBreadcrumbs, {
      entries: [{
        name: I18n.text('academyPublic.contentLandingPage.primaryDetails.breadcrumbs.home'),
        to: '/'
      }, {
        name: I18n.text('academyPublic.contentLandingPage.primaryDetails.breadcrumbs.library'),
        to: '/courses'
      }, ...(parentName && parentPath ? [{
        name: parentName,
        to: `/courses/${parentPath}`
      }] : []), ...(name ? [{
        name
      }] : [])],
      use: "on-light"
    }), /*#__PURE__*/_jsxs(CardGrid, {
      gap: "1400",
      gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fill, minmax(350px, 1fr))',
      children: [/*#__PURE__*/_jsxs("div", {
        children: [headline && /*#__PURE__*/_jsxs(H2, {
          color: "text-core-default",
          "data-test-id": "public-course-headline",
          children: [headline, ":"]
        }), name && /*#__PURE__*/_jsx(H1, {
          color: "text-core-default",
          "data-test-id": "public-course-name",
          children: name
        }), /*#__PURE__*/_jsx(Tag, {
          marginBlockEnd: "400",
          children: CONTENT_TYPE_MESSAGE[contentType]
        }), description &&
        /*#__PURE__*/
        // @bend-expect trellis-tokenized
        _jsx(Description, {
          $use: "on-light",
          dangerouslySetInnerHTML: {
            __html: description
          },
          "data-test-id": "public-course-description"
        })]
      }), /*#__PURE__*/_jsx(View, {
        position: "relative",
        children: /*#__PURE__*/_jsx(View, {
          backgroundColor: "fill-field-default-alt",
          boxShadow: "400",
          inlineSize: "100%",
          minBlockSize: "800px",
          position: isMobile ? 'relative' : 'absolute',
          ref: ref,
          children: /*#__PURE__*/_jsx(EmbeddedSignup, {
            id: id,
            pagePath: pagePath,
            type: contentType
          })
        })
      })]
    })]
  });
});
export default PublicLandingPagePrimaryDetails;